import { Component, AfterViewInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, ComponentRef, OnInit } from '@angular/core';
import { frequencyAlertMenu, SETTINGS_MENU } from './setttings.data';
import { YourProfileViewToOthersComponent } from '../your-profile-view-to-others/your-profile-view-to-others.component';
import { LoginAndSecurityComponent } from '../login-and-security/login-and-security.component';
import * as RolesRouteMap from 'src/app/data/constants/roles';
import { Router } from '@angular/router';
import * as Roles from 'src/app/data/constants/roles';
import { VideoCallLinkComponent } from './video-call-link/video-call-link.component';
import { DocumentExpiryAlertSettingsComponent } from '../document-expiry-alert-settings/document-expiry-alert-settings.component';
import { ReferenceLibraryService } from 'reference-library';
import { ChangeLanguageComponent } from '../change-language/change-language.component';

@Component({
  selector: 'app-settings-landing',
  templateUrl: './settings-landing.component.html',
  styleUrls: ['./settings-landing.component.scss']
})
export class SettingsLandingComponent implements OnInit, AfterViewInit {
  settings_menu: object[];
  settings_sub_menu: object[];
  activeComponentkey = '';
  componentkey = '';
  componentName;
  activeMainmenu;
  userTypeRole;
  @ViewChild('componentholder', { static: false, read: ViewContainerRef }) componentholder: ViewContainerRef;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
     private referenceLibraryService: ReferenceLibraryService,
    private router: Router) {
    this.settings_menu = [];
    this.settings_sub_menu = [];
    this.activeComponentkey = '';
    this.activeMainmenu = '';
    this.userTypeRole = '';
  }

  ngOnInit() {
    this.userTypeRole = sessionStorage.getItem('userTypeRole');
    this.menuSetup();
  }

  ngAfterViewInit() {
    if (sessionStorage.getItem('userTypeRole') === Roles.BENEFICIARY ||
      sessionStorage.getItem('userTypeRole') === Roles.PETITIONER ||
      sessionStorage.getItem('userTypeRole') === Roles.ATTORNEY||
      sessionStorage.getItem('userTypeRole') === Roles.I9ADMIN) {
      this.menuSetup();
      this.createInitialSubMenu();
    }
    this.translet();
  }

  translet() {
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);
  }

  menuSetup() {
    this.settings_menu = [...SETTINGS_MENU];
    if (this.userTypeRole === 'Petitioner' || this.userTypeRole === 'Attorney' || this.userTypeRole === 'I9Admin') {
      this.settings_menu.shift();
      this.settings_menu = [...this.settings_menu, frequencyAlertMenu]
    }
  }

  createInitialSubMenu() {
    this.settings_sub_menu = this.settings_menu[0]['sub-titles'];
    this.activeMainmenu = this.settings_menu[0]['main-title-key'];
    const componentkey = this.settings_sub_menu[0]['key'];
    this.loadComponent(componentkey);
  }



  fetchSubmenuitems(index) {
    //  console.log(index);
    this.activeMainmenu = this.settings_menu[index]['main-title-key'];
    this.settings_sub_menu = this.settings_menu[index]['sub-titles'];
    const componentkey = this.settings_sub_menu[0]['key'];
    this.loadComponent(componentkey);
  }

  loadComponent(componentkey): void {
    let componentFactory;
    let componentRef;
    if (componentRef) {
      componentRef.destroy();
    }
    this.componentholder ? this.componentholder.length ? this.componentholder.remove(0) : '' : '';
    if (componentkey == 'loginAndSecurity') {
      componentFactory = this.componentFactoryResolver.resolveComponentFactory(LoginAndSecurityComponent);
      componentRef = this.componentholder.createComponent(componentFactory);
      this.activeComponentkey = componentkey;
    }
    if (componentkey == 'profileViewForOthers') {
      componentFactory = this.componentFactoryResolver.resolveComponentFactory(YourProfileViewToOthersComponent);
      componentRef = this.componentholder.createComponent(componentFactory);
      this.activeComponentkey = componentkey;
    }
    if (componentkey == 'changeLanguage') {
      componentFactory = this.componentFactoryResolver.resolveComponentFactory(ChangeLanguageComponent);
      componentRef = this.componentholder.createComponent(componentFactory);
      this.activeComponentkey = componentkey;
    }
    if (componentkey == 'documentsExpiry') {
      componentFactory = this.componentFactoryResolver.resolveComponentFactory(DocumentExpiryAlertSettingsComponent);
      componentRef = this.componentholder.createComponent(componentFactory);
      this.activeComponentkey = componentkey;
    }
    if (componentkey == 'videoCallLink') {
      componentFactory = this.componentFactoryResolver.resolveComponentFactory(VideoCallLinkComponent);
      componentRef = this.componentholder.createComponent(componentFactory);
      this.activeComponentkey = componentkey;
    }
    // componentRef.instance.index

  }


  backToDashboard() {
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/${sessionStorage.getItem('userTypeRole') === RolesRouteMap.ATTORNEY ? 'attorney' : (sessionStorage.getItem('userTypeRole') === RolesRouteMap.BENEFICIARY) ? 'beneficiary' : 'petitioner'}-dashboard`]);
  }


}

